import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@goaltree/ui/components/dropdown-menu'
import { useNavigate } from '@tanstack/react-router'
import { BookOpen, MoreVertical, Search } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { IconTip } from '@/components/icon-tip'

export function TodayHeaderMenu() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <>
      <DropdownMenu>
        <IconTip label={t('goalSheet.more')}>
          <DropdownMenuTrigger
            aria-label={t('goalSheet.more')}
            className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground data-popup-open:bg-muted data-popup-open:text-foreground"
          >
            <MoreVertical className="h-5 w-5" strokeWidth={1.5} />
          </DropdownMenuTrigger>
        </IconTip>
        <DropdownMenuContent align="end" className="w-44">
          <DropdownMenuItem
            className="cursor-pointer px-3 font-medium"
            onClick={() => window.dispatchEvent(new CustomEvent('open-search'))}
          >
            <Search className="text-muted-foreground" strokeWidth={1.5} />
            <span>{t('nav.search')}</span>
          </DropdownMenuItem>
          <DropdownMenuItem
            className="cursor-pointer px-3 font-medium"
            onClick={() => void navigate({ to: '/journal' })}
          >
            <BookOpen className="text-muted-foreground" strokeWidth={1.5} />
            <span>{t('nav.journal')}</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
